module.exports = __webpack_public_path__ + "img/8.0f445ca1.png";